import { useEffect } from "react";
import { track } from "@/lib/analytics";

/**
 * Convenience: fires a tracking event once on mount.
 * Use for top-of-page view events.
 */
export function useTrackPageView<T extends Record<string, unknown>>(
  event: Parameters<typeof track>[0],
  props?: T,
) {
  useEffect(() => {
    track(event as never, props as never);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
